import { render, staticRenderFns } from "./HomeMyFeed.vue?vue&type=template&id=3609335e&"
import script from "./HomeMyFeed.vue?vue&type=script&lang=js&"
export * from "./HomeMyFeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "HomeMyFeed.vue"
export default component.exports